import { render, staticRenderFns } from "./edito-steps.vue?vue&type=template&id=dcdded38"
import script from "./edito-steps.vue?vue&type=script&lang=js"
export * from "./edito-steps.vue?vue&type=script&lang=js"
import style0 from "./edito-steps.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default,PatternsBadgePill: require('/home/node/app/components/patterns/badge-pill/badge-pill.vue').default})
